import { tomanAnimated, tomanAnimatedDark, tomanLogo, tomanLogoDark } from "../../assets/images";
import type { ThemeMode } from "./theme";

export const getTomanLogoSrc = (theme: ThemeMode) => (theme === "dark" ? tomanLogoDark : tomanLogo);

export const getTomanAnimatedLogoSrc = (theme: ThemeMode) =>
  theme === "dark" ? tomanAnimatedDark : tomanAnimated;
